import React       from 'react';
import ReactDom    from 'react-dom';
import Moment      from 'moment';

import Const       from 'fw_const';
import Utils       from 'utils';

import ContentsModal    from 'contents_modal';
// -------------------------------------------------------

class Keyword extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      type  : 'or',
      label : [],
    };
  }
  // -------------------------------------------------------
  
  /*
   * AND / OR変更
   */
  changeType(type) {
    this.setState({ type: type });
    this.changeSetting.bind(this)(this.state.label, type);
  }
  // -------------------------------------------------------
  
  /*
   * ラベルの設定
   */
  setLabel(data) {
    let label = this.state.label.concat();
    label.push(data);
    this.setState({ label: label });
    
    this.changeSetting.bind(this)(label, this.state.type);
  }
  // -------------------------------------------------------
  
  /*
   * ラベルの削除
   */
  deleteLabel(data) {
    let label = this.state.label.concat();
    label = label.filter((d) => { if( d.label_hash != data.label_hash ) return d; });
    this.setState({ label: label });
    
    this.changeSetting.bind(this)(label, this.state.type);
  }
  // -------------------------------------------------------
  
  changeSetting(label, type) {
    
    if( JSON.stringify(label) != JSON.stringify(this.state.label) && type != this.state.type ){
      this.props.set_ev.bind(this)('label', label, true);
      this.props.set_ev.bind(this)('label_type', type);
    } else if( JSON.stringify(label) != JSON.stringify(this.state.label) ){
      this.props.set_ev.bind(this)('label', label);
    } else if( type != this.state.type ){
      this.props.set_ev.bind(this)('label_type', type);
    }
  }
  // -------------------------------------------------------
  
  render() {
    let type_list = [{ id: 'or', name: 'OR' }, { id: 'space'}, { id: 'and', name: 'AND' }];
    
    return (
      <div className="column">
        <h6>ラベル</h6>
        <ul className="labels">
          { this.state.label.map((d, key) => { return <li key={key}>{d.name}<span onClick={this.deleteLabel.bind(this, d)}>×</span></li> })}
          <AddLabel set_label={this.state.label} set_ev={this.setLabel.bind(this)} />
        </ul>
        
        <div className="column-type">
          { type_list.map((d, key) => {
            if( d.id == 'space' ) return <p key={key} className="slash">/</p>;
            
            let flg = (d.id == this.state.type) ? 'on' : 'off';
            return <p key={key} className={flg} onClick={this.changeType.bind(this, d.id)}>{d.name}</p>
          })}
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

class AddLabel extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      view        : false,
      labels      : [],
      search_word : null,
    };
  }
  // -------------------------------------------------------
  
  /*
   * ラベルデータ取得
   */
  modal_show() {
    Utils.request.bind(this)('/api/influencer/get_labels', {},
      function(res){
        this.setState({ view: true, labels: res.body.labels });
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  /*
   * モーダル表示 / 非表示
   */
  modal_close(props) {
    this.setState({ view: false, search_word: '' });
  }
  // -------------------------------------------------------
  
  /*
   * データ設定
   */
  modal_set(data) {
    this.props.set_ev.bind(this)(data);
    this.setState({ view: false });
  }
  // -------------------------------------------------------
  
  changeKeyword() {
    this.setState({ search_word: this.keyword.value });
  }
  // -------------------------------------------------------
  
  render() {
    let tab = this.state.tab;
    
    let search_word = this.state.search_word;
    
    return (
      <li className="add">
        <p onClick={this.modal_show.bind(this)}>+</p>
        
        <ContentsModal
          view     = {this.state.view}
          width    = {330}
          height   = {420}
          close_ev = {this.modal_close.bind(this)}
          html     = {
            <div className="modal-item">
              <h2>調査したいラベルを選択</h2>
              
              <div className="sub-menu">
                <a href="/label/management" target="_blank">ラベルの一括管理</a>
                
                <div className="search-box">
                  <input className="text" type="text" ref={(input) => { this.keyword = input }} onChange={this.changeKeyword.bind(this)} placeholder="投稿を検索" />
                  <i className="material-icons">search</i>
                </div>
              </div>
              
              <ul className="labels label-modal-item">
                { this.state.labels.map((d, key) => {
                  if( search_word != null && search_word != '' && (d.name.indexOf(search_word) == -1)) return null;
                  
                  let flg = true;
                  this.props.set_label.map((s) => { if( s.label_hash == d.label_hash ) flg = false; });
                  if( flg == false ) return null;
                  
                  return <li key={key} className={'count_'+ String(d.tally_count).length} onClick={this.modal_set.bind(this, d)}>{d.name}<i className="count">{Utils.viewInt(d.tally_count)}</i></li>;
                })}
              </ul>
            </div>
          }
        />
      </li>
    );
  }
}
// -------------------------------------------------------


// レンダリング処理
export default Keyword;